import script from "./nav-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./nav-bar.vue?vue&type=script&setup=true&lang=js"

import "./nav-bar.vue?vue&type=style&index=0&id=18dc9111&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18dc9111"]])

export default __exports__